module.exports = __webpack_public_path__ + "91ba264f70d3118fdce04682b3a4cb3a.png";